import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Amplify from 'aws-amplify';
import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withAuthenticator } from './aws-amplify-react/Auth/index';
import PageHeader from './pages/PageHeader';
import Routes from './Routes';
import * as CONFIG from './api/config';
// import { version } from '../package.json';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Auth } from 'aws-amplify';
import * as Icon from 'react-feather';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import ContainerUnAuth from './pages/containerUnAuth';
require('./bmd.css');
require('./footer.css');
Amplify.configure(CONFIG.aws_cognito);
const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      light: '#0066ff',
      main: '#318fa9',
      // contrastText: '#ffcc00',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      light: '#387025',
      main: '#387025',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#CDEEF5',
    },
    typography: {
      fontFamily: 'Josefin Sans',
    }
  },
});

const styles = {
  root: {
    flexGrow: 1,
    background: "#318fa9",

  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  button: {
    color: '#B2EBF2',
    background: "#318fa9",
  },
  select: {
    backgroundColor: '#318fa9'
  },
  normal: {
    backgroundColor: '#fff'
  },
  select1: {
    color: '#fff'
  },
  normal1: {
    color: '#318fa9'
  }


  //# 0 d7782
};



class AppUnAuth extends Component {
  state = {
    auth: true,
    anchorEl: null,
    loginMenuItem: 'Logout',
    open: true,
    selectedindex: 0,
  };

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };
  handleLogout = async () => {
    try {
      localStorage.removeItem('profession');
      await Auth.signOut();
    }
    catch (ex) { }
    // this.props.history.push("/signout");
    //   Auth.signOut().then(() => {
    //   console.log('signedOut');
    // }).catch(err => {
    //   console.log(err);
    //   this.error(err);
    // });
    this.setState({ anchorEl: null, loginMenuItem: 'Login', });
  }
  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
  };
  componentDidMount() {
    const ele = document.getElementById('ipl-progress-indicator')
    if (ele) {
      // fade out
      ele.classList.add('available')
      setTimeout(() => {
        // remove from DOM
        ele.innerHTML = ''
      }, 2000)
    }
  }

  render() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <div className="flyout" style={{ overflowX: 'hidden' }}>
            {<ContainerUnAuth />}
          </div>
        </MuiThemeProvider>
      </Router>
    );
  }
}

export default AppUnAuth;
